// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"544":"c48d1fba","845":"3a4d01c7"}[chunkId] + ".chunk.js";
};